import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NormalizeRouteCase = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);

    const normalizedPathParts = pathParts.map((part, index) => {
      if (index === 0 || part === "hospital" || part === "classroom") {
        return part;
      }
      return part.charAt(0).toUpperCase() + part.slice(1);
    });

    const normalizedPath = `/${normalizedPathParts.join("/")}`;
    if (location.pathname !== normalizedPath) {
      navigate(normalizedPath, { replace: true });
      window.location.reload();
    }
  }, [location, navigate]);

  return <>{children}</>;
};

export default NormalizeRouteCase;
